import { Component, Inject, ElementRef, NgZone, OnInit, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { ConstantsService } from '@app/base/core';

declare var google: any;
declare var swal: any;
require('sweetalert');

@Component({
    selector: 'address-autocomplete',
    template: `
<div class="form-group"  id="addressSearchText">
<label>{{label}}</label>
  <input type="search" [(ngModel)]="addressSearchText" class="form-control input-lg"
  placeholder="Enter Address for Search" autocorrect='on' (keyup)="onKeyUp()"
    #search autocapitalize='on' spellcheck='off'>
</div>
    `,
})

/* istanbul ignore next */
export class AutocompleteComponent implements OnInit, AfterViewInit {
  @Input() adressType = 'address';
  @Input() label: string = null;
  @Output() getSelectedAddress = new EventEmitter();
  @Output() getAddress = new EventEmitter();
  public searchControl: FormControl;
  public showAddress = true;
  @Input() addressSearchText: string;
  selectedAddress: any = {};
  @ViewChild('search', {static: false})
  public searchElementRef: ElementRef;

  constructor(
    @Inject(MapsAPILoader) private mapsAPILoader: MapsAPILoader,
     @Inject(NgZone) private ngZone: NgZone,
     public constantsSvc: ConstantsService) {}

  /* istanbul ignore next */
  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      this.searchControl = new FormControl();
      const options = { componentRestrictions: { country: 'US' }, types: [this.adressType]  };
      const autocomplete = new google.maps.places.SearchBox(this.searchElementRef.nativeElement, options);

      autocomplete.addListener('places_changed', () => {
        this.ngZone.run(() => {
          const place: any = autocomplete.getPlaces();
          if (place.length === 0) {
            swal(this.constantsSvc.addressNotFoundSwal, this.constantsSvc.addressSwal1, this.constantsSvc.warningSwal);
           return;
          }

          if (place[0].address_components != null) {
            this.selectedAddress = this.parseAddress(place[0]);
            this.getSelectedAddress.emit(this.selectedAddress);
          }
        });
      });
    });
  }
  ngAfterViewInit(): void {

  }

  onKeyUp() {
    this.getAddress.emit(this.addressSearchText);
  }
  /* istanbul ignore next */
  parseAddress(addressObj) {
    const address: any = {};
    if (addressObj != null) {
      // loop through to get address, city, state, zip
      addressObj.address_components.forEach(element => {
        switch (element.types[0]) {
          case 'route':
            address.street_name = element.short_name;
            break;
          case 'street_number':
            address.street_number = element.short_name || '';
            break;
          case 'locality':
            address.city = element.short_name;
            break;
          case 'administrative_area_level_2':
            address.county = element.long_name.substring(0, element.long_name.length - 7);
            break;
          case 'administrative_area_level_1':
            address.state = { long_name: element.long_name, short_name: element.short_name };
            break;
          case 'postal_code':
            address.zip = element.short_name;
            break;
          case 'country':
            address.country = element.short_name;
            break;
        }
      });
    }
    address.formatted_address = addressObj.formatted_address;
    address.latitude =  addressObj.geometry.location.lat();
    address.longitude = addressObj.geometry.location.lng();
    return address;
  }
}
interface Marker {
  latitude: number;
  longitude: number;
  draggable: boolean;
}







